export default __webpack_public_path__ + "static/media/users-off.813387e5.svg";